// src/components/DeleteConfirmationModal.js - Reusable Delete Confirmation Modal
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import WarningIcon from '@mui/icons-material/Warning';

const DeleteConfirmationModal = ({ 
  show, 
  onConfirm, 
  onCancel, 
  title = "Confirm Delete",
  message,
  itemName,
  itemType = "item",
  confirmText = "Delete",
  cancelText = "Cancel"
}) => {
  if (!show) return null;

  const defaultMessage = itemName 
    ? `Are you sure you want to delete "${itemName}"?`
    : `Are you sure you want to delete this ${itemType}?`;

  return (
    <div className="modal-overlay">
      <div className="delete-confirmation-modal">
        <div className="modal-header">
          <div className="modal-title-section">
            <WarningIcon className="warning-icon" />
            <h3>{title}</h3>
          </div>
        </div>
        
        <div className="modal-content">
          <div className="delete-warning-content">
            <p className="delete-message">
              {message || defaultMessage}
            </p>
            {itemName && (
              <div className="item-preview">
                <strong>{itemName}</strong>
              </div>
            )}
            <p className="delete-warning">
              This action cannot be undone.
            </p>
          </div>
        </div>
        
        <div className="modal-footer">
          <div className="modal-footer-left">
            {/* Empty for layout consistency */}
          </div>
          <div className="modal-footer-right">
            <button 
              className="cancel-btn"
              onClick={onCancel}
            >
              {cancelText}
            </button>
            <button 
              className="delete-btn danger"
              onClick={onConfirm}
            >
              <DeleteIcon className="btn-icon" />
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;